
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/model';
import { CardsClient, DeferredPaymentClient } from '@/services/Services';
import Swiper from 'swiper';
import { Prop, Watch } from 'vue-property-decorator';
import fullImageModal from './fullImageModal.vue';

@Options({})
export default class gallery extends Vue {

    @Prop() gallery: OM.Attachment[];

    swiperEl: Swiper = null;

    mounted(){
        this.swiperEl = this.$refs.swiperContainer as Swiper;
    }

    openFullImage(item: OM.Attachment){
        this.$opModal.show(fullImageModal, {
            imgPreview: item.publicUrl
        })
    }

}
